export enum DiagnosisType {
    Principle = 1,
    Final = 2,
    Secondary = 3,
    Admitting = 4,
    Discharge = 5,
    Differential = 6
}